import * as React from 'react'
import { DisplayContent } from 'react-content-engine'
import Airport from '../airport'
import { destinationEnum } from './destination'
import { driveDestinations } from './driveDestination'

export * from './times'

function getDestinationPlaceholder(value: destinationEnum) {
  switch (+value) {
    case destinationEnum.allOfEurope: {
      return 'Anywhere in Europe'
    }
    case destinationEnum.outsideEurope: {
      return 'Outside of Europe'
    }
    case destinationEnum.northEurope: {
      return 'Somewhere in Northern Europe'
    }
    case destinationEnum.eastEurope: {
      return 'Somewhere in Eastern Europe'
    }
    case destinationEnum.southEurope: {
      return 'Somewhere in Southerm Europe'
    }
    case destinationEnum.westEurope: {
      return 'Somewhere in Westerm Europe'
    }
    default: {
      return 'Not in enum'
    }
  }
}
function getDrivePlaceholder(value: driveDestinations) {
  switch (+value) {
    case driveDestinations.surprise: {
      return 'Surprise me'
    }
    case driveDestinations.rural: {
      return 'Rural'
    }
    case driveDestinations.urban: {
      return 'Urban'
    }
    default: {
      return 'Not in enum'
    }
  }
}

export function getDestination(value: destinationEnum) {
  return (
    <DisplayContent
      contentKey={`destination-${destinationEnum[value]}-summary`}
    >
      {getDestinationPlaceholder(value)}
    </DisplayContent>
  )
}

export function getDriveDestination(value: driveDestinations) {
  return (
    <DisplayContent
      contentKey={`driveDestination-${driveDestinations[value]}-summary`}
    >
      {getDrivePlaceholder(value)}
    </DisplayContent>
  )
}

export function getAirportNames(airports: Airport[]) {
  const names = []
  names.push(
    <DisplayContent key={-1} contentKey="airport">
      Airport
    </DisplayContent>,
  )
  names.push(` `)
  if (airports) {
    for (let i = 0; i < airports.length; i++) {
      names.push(airports[i].name)
      if (i === airports.length - 2) {
        names.push(` `)
        names.push(
          <DisplayContent key={i} contentKey="or">
            or
          </DisplayContent>,
        )
        names.push(` `)
      } else if (i !== airports.length - 1) {
        names.push(`, `)
      }
    }
  }
  return names
}
